import { render } from "./edit.vue?vue&type=template&id=532333a9&scoped=true"
import script from "./edit.vue?vue&type=script&lang=js"
export * from "./edit.vue?vue&type=script&lang=js"

import "./edit.vue?vue&type=style&index=0&id=532333a9&lang=less&scoped=true"

import exportComponent from "/var/www/html/pro-cms-dtinsights/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-532333a9"]])

export default __exports__